"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CBAConfig = void 0;
var _cbaThemeContext = require("./cbaThemeContext");
var _cbaAboutOwner = require("./quoteTools/cbaAboutOwner");
var _cbaAboutPet = require("./quoteTools/cbaAboutPet");
var _cbaCoverDisplayOptions = require("./quoteTools/cbaCoverDisplayOptions");
var _cbaQuoteToolContext = require("./quoteTools/cbaQuoteToolContext");
var _cbaStepDefinitions = require("./quoteTools/cbaStepDefinitions");
var _cbaSuccess = require("./quoteTools/cbaSuccess");
var _cbaSummary = require("./quoteTools/cbaSummary");
var _cbaAuthorisedPersonDisplaySettings = require("./quoteTools/cbaAuthorisedPersonDisplaySettings");
var _icons = require("./productTable/icons");
var _defaultCustomRouteDefinitions = require("../../defaults/quoteTools/defaultCustomRouteDefinitions");
var _defaultRegularVetDisplaySettings = require("../../defaults/quoteTools/defaultRegularVetDisplaySettings");
var _defaultOptionalInclusions = require("../../defaults/productTable/staff/defaultOptionalInclusions");
var _defaultStaffInstructions = require("../../defaults/productTable/staff/defaultStaffInstructions");
var _defaultStaffContext = require("../../defaults/quoteTools/staff/defaultStaffContext");
var _defaultPayment = require("../../defaults/quoteTools/defaultPayment");
var CBAConfig = exports.CBAConfig = {
  theme: _cbaThemeContext.CBAThemeContext,
  quoteTools: {
    transmitSecurity: {
      enabled: true,
      sit: {
        clientId: 'isrrzb2epjdcsxnaopadqyuy3dg4jrez'
      },
      uat: {
        clientId: 'isrrzb2epjdcsxnaopadqyuy3dg4jrez'
      },
      preprod: {
        clientId: 'isrrzb2epjdcsxnaopadqyuy3dg4jrez'
      },
      prod: {
        clientId: 'LtXbxqsWtXd6zbbIrFxFM'
      }
    },
    themeOverrides: _cbaQuoteToolContext.CbaQuoteToolContext,
    steps: {
      StepDefinitions: _cbaStepDefinitions.CbaStepDefinitions,
      basicOwnerDetails: _cbaAboutOwner.CbaBasicOwnerDetails,
      fullOwnerDetails: _cbaAboutOwner.CbaFullOwnerDetails,
      aboutPet: _cbaAboutPet.CbaAboutPet,
      coverDisplayOptions: _cbaCoverDisplayOptions.CbaCoverDisplayOptions,
      summary: _cbaSummary.CbaSummary,
      success: _cbaSuccess.CbaSuccess,
      payment: _defaultPayment.defaultPayment,
      bannerStyle: 'bullets',
      showCompletedStepBannerOnPage: 'step6'
    },
    widgets: {
      authorisedPersonDisplaySettings: _cbaAuthorisedPersonDisplaySettings.cbaDefaultAuthorisedPersonDisplaySettings,
      regularVetDisplaySettings: _defaultRegularVetDisplaySettings.defaultRegularVetDisplaySettings
    },
    customRouteDefinitions: _defaultCustomRouteDefinitions.DefaultCustomRouteDefinitions,
    staffModeContext: _defaultStaffContext.DefaultStaffModeContext,
    productTable: {
      optionalInclusions: _defaultOptionalInclusions.DefaultOptionalInclusions,
      staffInstructions: _defaultStaffInstructions.DefaultStaffInstructions,
      icons: _icons.icons
    },
    middlewareApiKeys: {
      "public": {
        sit: {
          applicationId: '0D9D1963-497B-4097-910A-60B0E47F7E33',
          apiKey: '8XOCACB02C3DPSZLA',
          expiry: 3600
        },
        uat: {
          applicationId: '0D9D1963-497B-4097-910A-60B0E47F7E33',
          apiKey: '8XOCACB02C3DPSZLA',
          expiry: 3600
        },
        preprod: {
          applicationId: '0C53C2C7-2662-496B-BD05-777A08DEB54C',
          apiKey: 'SL8XOCACB02C3DPSZ',
          expiry: 3600
        },
        prod: {
          applicationId: '76731D28-AF35-436F-8369-91D4C3FC72B3',
          apiKey: 'OCACB02C3DPSZLACF',
          expiry: 3600
        }
      }
    },
    recaptchaSiteKey: '6LcjnoIpAAAAAIPrgxnTio8rn55lt0AVIIiZM8Qr',
    recaptchaSecretKey: '6LcjnoIpAAAAAEGYh9j-18qRa0Q2qkIXhN6oxP5C',
    recaptchaSiteKeyProd: '6LeynoIpAAAAALH4Fnwxg8-3rOGXAM2ubnxfI-0a',
    recaptchaSecretKeyProd: '6LeynoIpAAAAAIqw57Inl0UV4YXMyYUS0edUtjJy'
  }
};